<template>
    <vs-popup class="popup_member_add chat_cont_popup" :title="$t('add_user_to_chat')" :active.sync="popupActive">
        <vs-input v-model="search" @input="memberSearch" icon-pack="feather" icon="icon-search" class="w-full mb-3" :placeholder="$t('enter_your_username')" />
        <component
            :is="'VuePerfectScrollbar'"
            ref="popupScroll"
            class="popupScroll popup_add_scroll"
            @ps-y-reach-end="getContactsList"
            :settings="settings"
            :key="$vs.rtl">
                <ul class="chat__active-chats bordered-items">
                    <li class="cursor-pointer" v-for="(contact, index) in addMembersList" :key="index">
                        <ChatContact :clickSelect="true" :contact="contact" />
                    </li>
                </ul>
                <div v-show="status || searchStatus" class="vs-con-loading__container add_mem_popup_loader"></div>
        </component>
    </vs-popup>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import ChatContact from './ChatContact.vue'
import {mapState} from 'vuex'
let searchId
export default {
    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6
            },
            loading: false,
            page: 0,
            status: true,
            emptyMessage: false,
            search: '',
            searchStatus: false
        }
    },
    computed: {
        ...mapState({
            addMembersList: state => state.chat.addMembersList,
            moderate: state => state.chat.moderate
        }),
        popupActive: {
            get() {
                return this.$store.state.chat.addMemberPopup
            },
            set(val) {
                this.$store.commit('chat/SET_ADD_MEMBER_POPUP', val)
                if(!val) {
                    this.status = true
                    this.page = 0
                    this.loading = false
                    this.emptyMessage = false
                    this.search = ''
                    this.searchStatus = false
                    this.$store.commit('chat/CONCAT_ADD_MEMBERS_CLEAR')
                }
            }
        }
    },
    methods: {
        memberSearch(e) {
            clearTimeout(searchId)
            if(e.length > 2) {
                searchId = setTimeout(async() => {
                    try {
                        this.status = false
                        this.searchStatus = true
                        this.$nextTick(() => {
                            this.$vs.loading({
                                container: '.add_mem_popup_loader',
                                scale: 0.6
                            })
                        })
                        this.$store.commit('chat/CONCAT_ADD_MEMBERS_CLEAR')
                        this.loading = true
                        this.page = 1
                        const res = await this.$store.dispatch('chat/memberSearch', {value: e, page: this.page})
                        if(res && res.next) {
                            this.status = true
                            this.searchStatus = false
                        } else
                            this.emptyMessage = true

                    } catch(e) {

                    } finally {
                        this.loading = false
                        this.$vs.loading.close('.add_mem_popup_loader > .con-vs-loading')
                    }
                }, 800)
            }
            if(!e.length) {
                searchId = setTimeout(() => {
                    this.page = 0
                    this.loading = false
                    this.status = true
                    this.searchStatus = false
                    this.emptyMessage = false
                    this.$store.commit('chat/CONCAT_ADD_MEMBERS_CLEAR')
                    this.getContactsList()
                }, 800)
            }
        },
        async getContactsList() {
            if(!this.loading && this.status && this.popupActive) {
                try {
                    this.$nextTick(() => {
                        this.$vs.loading({
                            container: '.add_mem_popup_loader',
                            background: 'transparent',
                            scale: 0.6
                        })
                    })
                    this.loading = true
                    this.page = this.page+1
                    let res = null
                    if(this.search.length)
                        res = await this.$store.dispatch('chat/memberSearch', {value: this.search, page: this.page})
                    else
                        res = await this.$store.dispatch('chat/getContacts', {page: this.page, add: true})

                    if(!res.next)
                        this.status = false
                } catch(e) {

                } finally {
                    this.$vs.loading.close('.add_mem_popup_loader > .con-vs-loading')
                    this.loading = false
                }
            }
        }
    },
    components: {
        VuePerfectScrollbar,
        ChatContact
    }
}
</script>

<style lang="scss">
.add_mem_popup_loader{
    position: relative;
    padding: 20px 0;
    .con-vs-loading{
        position: absolute;
    }
}
@media only screen and (min-width: 893px) {
    .popupScroll{
        max-height: 312px;
    }
}
@media only screen and (max-width: 892px) {
    .popupScroll{
        &.popup_add_scroll{
            height: calc(100% - 48.09px);
        }
    }
}
</style>
